import {createAction, props} from '@ngrx/store';

export enum ParametryBiznesoweActionTypes {
  AKTUALIZUJ_PARAMETR = '[Parametry Biznesowe] aktualizuj',
}

export const aktualizujParametrBiznesowy = createAction(
  ParametryBiznesoweActionTypes.AKTUALIZUJ_PARAMETR,
  props<{ nazwa: string, wartosc: string | number }>()
);
